import React from 'react';
import ArticleLayout from '../../components/ArticleLayout/ArticleLayout';
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import { monokai } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { Helmet } from 'react-helmet';

const ArticleApiFT = () => {
  return (
    <ArticleLayout
      title="Integrating the FlashTalking Library via Code"
      subtitle=""
    >
      <Helmet>
        <title>Integrating the FlashTalking Library via Code</title>
      </Helmet>

      <h2 className="article-section-title">Standard</h2>
      <ol>
        <li>Remove any click commands and URL redirects from the ad.</li>
        <li>
          Create a <strong>manifest.js</strong> file and save it alongside <strong>index.html</strong> in the root of the project.
          Add the following information:
        </li>
        <div className="code-block">
          {`FT.manifest({
  "filename":"index.html",
  "width":300,
  "height":250,
  "clickTagCount":1
});`}

        </div>
      </ol>

      <h2 className="article-section-title">Rich Media</h2>
      <ol>
        <li>Remove any click commands and URL redirects from the ad.</li>
        <li>
          Create a <strong>manifest.js</strong> file and save it alongside <strong>index.html</strong>.
        </li>
        <div className="code-block">
          {`FT.manifest({
  "filename":"index.html",
  "width":300,
  "height":250,
  "clickTagCount":1
});`}

        </div>
        <li>
          Add the call to our library and insert a script with the click command:
        </li>
        <div className="code-block">
          {`<script src="https://cdn.flashtalking.com/frameworks/js/api/2/10/html5API.js"></script>
<script>
  var container = myFT.$("#container");
  container.on("click", function() {
    myFT.clickTag(1);
  });
</script>`}
        </div>
      </ol>
    </ArticleLayout>
  );
};

export default ArticleApiFT;
